import React from "react";
import DpNewRequest from "./DpNewRequest";
import AssignCustomerBrigadeRequest from "./assignCustomerBirgadeRequest";
import OnWayCustomerRequest from "./onWayCustomerRequest";
import {useAppSelector} from "../../../core/hooks";
import SentryStart from "./SentryStart";
import CustomerErHospitalization from "./CustomerErHospitalization";
import CustomerCancelHospitalization from "./CustomerCancelHozpitalization";
import HistoryPanel from "../../er-request/history-panel";
import CustomerCommentsPanel from "./cutomer-comments-panel";
import {RequestTypes} from "../../../services/constants";
import {
  Arrived,
  AssignBrigade,
  BookingApproved,
  Closed,
  Hospitalization, New,
  OnWay, OnWayToHospital, Stationing
} from "../../emergencyCall/DpRequestComponents";
import ScheduledStart from "../../scheduledCall/DpScheduledComponents/ScheduledStart";

const DpContent = () => {
  const { er_call, activePanel, request} = useAppSelector(state => state.requests)
  let Content: any

  if (activePanel === 'data' && request.type === RequestTypes.Sentry) {
    if (!er_call) {
      return <div style={{
        display: "flex",
        flexDirection: "column",
        height: " 100%",
        overflow: "auto",
        overflowX: "hidden",
        width: "100%"
      }}>
          <DpNewRequest/>
      </div>
    } else {
      switch (er_call.status) {
        case 1:
          Content = <AssignCustomerBrigadeRequest/>
          break;
          case 2:
          case 3:
          Content = <OnWayCustomerRequest/>
          break;
          case 4:
          Content = <SentryStart/>
          break;
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 15:
          case 16:
          case 17:
          case 18:
          case 22:
          case 24:
          Content = <CustomerCancelHospitalization/>
          break;
          case 23:
          Content = <CustomerErHospitalization/>
          break;
      }
    }
  } else if (activePanel === 'data' && request.type === RequestTypes.Emergency) {
    if (!er_call) {
      return <div style={{
        display: "flex",
        flexDirection: "column",
        height: " 100%",
        overflow: "auto",
        overflowX: "hidden",
        width: "100%"
      }}>
        <DpNewRequest/>
      </div>
    } else {
      switch (er_call.status) {
        case 1:
          Content = <AssignCustomerBrigadeRequest/>
          break;
        case 2:
        case 3:
          Content = <OnWayCustomerRequest/>
          break;
        case 4:
          Content = <Arrived/>
          break;
        case 5:
        case 6:
          Content = <Closed/>
          break;
        case 7:
        case 8:
        case 16:
        case 26:
          Content = <Hospitalization/>
          break;
        case 9:
        case 27:
          Content = <BookingApproved/>
          break;
        case 10:
        case 22:
          Content = <OnWayToHospital/>
          break;
        case 11:
          Content = <Stationing/>
          break;
        case 12:
        case 17:
        case 18:
          Content = <Closed/>
          break;
        case 13:
        case 14:
        case 19:
        case 20:
        case 21:
          Content = <OnWay/>
          break;
        case 15:
          Content = <DpNewRequest/>
          break;
        default:
          Content = ''
      }
    }
  } else if (activePanel === 'data' && request.type === RequestTypes.Scheduled) {
    if (!er_call) {
      return <div style={{
        display: "flex",
        flexDirection: "column",
        height: " 100%",
        overflow: "auto",
        overflowX: "hidden",
        width: "100%"
      }}>
        <DpNewRequest/>
      </div>
    } else {
      switch (er_call.status) {
        case 1:
          Content = <AssignCustomerBrigadeRequest/>
          break;
        case 2:
        case 3:
        case 25:
          Content = <OnWayCustomerRequest/>
          break;
        case 4:
          Content = <ScheduledStart/>
          break;
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 15:
        case 16:
        case 17:
        case 18:
        case 22:
        case 24:
          Content = <ScheduledStart/>
          break;
        case 23:
          Content = <ScheduledStart/>
          break;
      }
    }
  }

  else if (activePanel === 'comment'){
    Content = <CustomerCommentsPanel isSentry={false}/>
  } else {
    // @ts-ignore
    Content = <HistoryPanel isDpSentry selectedModalBrigade={request.uuid}/>
  }



  return <>
    {Content}
  </>
}

export default DpContent
